var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import Navigation from '../model/Navigation';
import transformNavigation from './transformNavigation';
import { resolve } from '../util/path';
export default transformNavigation(function (navigation, store) {
  var to = navigation.to;

  if (to && store.location.pathname) {
    return new Navigation(_extends({}, navigation, {
      to: _extends({}, to, {
        pathname: resolve(store.location.pathname, to.pathname)
      })
    }));
  }

  return navigation;
});